module.exports = __webpack_public_path__ + "img/Xgrow-1-pt.87c06181.png";